import filterIcon from "../filter.svg";

interface IProps {
  className?: string
}

const FilterHeaderFilter = ({className}: IProps) => {
  return (
    <img className={className} src={filterIcon} alt="" aria-hidden="true" />
  )
};

export default FilterHeaderFilter;
